import React from "react";
import { Card, CardContent, CardHeader, Typography, Box, Button, Grid, FormControlLabel, Checkbox } from "@mui/material";

interface LegalTermsCardProps {
  companyName: string;
  companyNif: string;
  companyAddressType: string;
  companyMail: string;
  companyPhone: string;
  handleAccept: () => void;
  error:boolean;  
  apiError: boolean;
  isAccepted:boolean; 
  setIsAccepted: (value: boolean) => void;
  previousStep: () => void;
}

const LegalTermsCardEsp: React.FC<LegalTermsCardProps> = ({
  companyName,
  companyNif,
  companyAddressType,
  companyMail,
  companyPhone,
  handleAccept,
  error,
  apiError,
  isAccepted,
  setIsAccepted,
  previousStep
}) => {
  return (
    <Card sx={{ p: 2 }}>
      <CardHeader
        title={
          <Typography variant="h1" align="center">
            Términos legales
          </Typography>
        }
      />
      <CardContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "5px",
          }}
        >
          {/* Contenedor de términos legales */}
          <Box
            sx={{
              border: "1px solid black",
              borderRadius: "5px",
              padding: "20px",
              maxHeight: "53vh",
              overflowY: "scroll",
              backgroundColor: "white",
              marginBottom: "20px",
            }}
          >
            <Typography
              variant="body1"
              sx={{ marginBottom: "10px", textAlign: "center" }}
            >
              <strong>FORMULARIO KYC</strong>
            </Typography>
            <Typography variant="body1" sx={{ marginBottom: "10px" }}>
              <strong>
                Los datos del presente formulario se solicitan en cumplimiento
                de la normativa de prevención de blanqueo de capitales (Ley
                10/2010 y R.D. 304/2014)
              </strong>
            </Typography>
            <Typography
              variant="body1"
              sx={{ marginBottom: "10px", textAlign: "center" }}
            >
              <strong>POLÍTICA DE PROTECCIÓN DE DATOS</strong>
            </Typography>
            <Typography
              variant="body2"
              sx={{ marginBottom: "10px", textAlign: "center" }}
            >
              <strong>Información básica sobre protección de datos</strong>
            </Typography>
            <Typography variant="body2" sx={{ marginBottom: "10px" }}>
              <strong>Responsable de tratamiento:</strong> {companyName}
              <br />
              <strong>Finalidad:</strong> Identificación y comprobación de
              identidad de las personas que pretendan establecer relaciones de
              negocio o intervenir en operaciones con nosotros, de si actúa por
              cuenta propia o de terceros y del propósito e índole prevista de
              la relación de negocio, así como el origen de los fondos.
              <br />
              <strong>Legitimación:</strong> Cumplimiento de una obligación
              legal.
              <br />
              <strong>Destinatarios:</strong> Encargados de tratamiento:
              SEPBLAC, CPBCIM.
              <br />
              <strong>Derechos:</strong> Acceder, rectificar y suprimir los
              datos, así como otros derechos, como se explica en la siguiente
              información:
              <br />
              De conformidad con lo dispuesto en el artículo 32 bis.3 de la Ley
              10/2010, de 28 de abril, de Prevención del Blanqueo de Capitales y
              de la Financiación del Terrorismo (PBCFT), y de los artículos 13
              del Reglamento (UE) 2016/679 y 11 de la Ley Orgánica 3/2018, a
              continuación, procedemos a facilitarle la información preceptiva
              sobre el tratamiento de los datos personales a efectos de PBCFT:
            </Typography>
            <Typography variant="body1" sx={{ marginBottom: "10px" }}>
              <strong>¿Quien es el responsable del tratamiento?</strong>
            </Typography>
            <Typography variant="body2" sx={{ marginBottom: "10px" }}>
              {companyName}, s.l. con cif {companyNif}
              <br />
              {companyAddressType}
              <br />
              {companyMail}
              <br />
              Telf. {companyPhone}
            </Typography>
            <Typography variant="body1" sx={{ marginBottom: "10px" }}>
              <strong>¿Con qué finalidad tratamos sus datos personales?</strong>
            </Typography>
            <Typography variant="body2" sx={{ marginBottom: "10px" }}>
              Trataremos los datos personales proporcionados en este formulario
              y en la documentación adjunta aportada, así como la relativa a las
              operaciones realizadas con {companyName}, con el fin de
              identificar a las personas que pretendan establecer relaciones de
              negocio o intervenir en operaciones con nosotros, y comprobar su
              identidad, determinar si actúa por cuenta propia o de terceros y
              el propósito e índole prevista de la relación de negocio, así como
              el origen de los fondos.
            </Typography>

            <Typography variant="body1" sx={{ marginBottom: "10px" }}>
              <strong>
                ¿Es obligatorio proporcionar sus datos personales?
              </strong>
            </Typography>
            <Typography variant="body2" sx={{ marginBottom: "10px" }}>
              Es obligatorio proporcionar los datos personales indicados en este
              formulario, a fin de que este establecimiento pueda cumplir sus
              obligaciones legales. De lo contrario, {companyName} no podrá
              establecer/mantener relaciones de negocio o realizar operaciones
              con usted.
            </Typography>

            <Typography variant="body1" sx={{ marginBottom: "10px" }}>
              <strong>
                ¿Cuáles son nuestras obligaciones legales con respecto al
                tratamiento de datos personales a efectos de PBCFT?
              </strong>
            </Typography>
            <Typography variant="body2" sx={{ marginBottom: "10px" }}>
              De conformidad con la referida normativa, las entidades sujetas a
              esta normativa han de cumplir una serie de obligaciones legales
              con respecto al tratamiento de datos personales a efectos de
              PBCFT, que, en términos generales, incluyen la obligación de
              informar sobre dicho tratamiento; no utilizar los datos para fines
              distintos sin el consentimiento del interesado, salvo que el
              tratamiento sea necesario para la gestión ordinaria de la relación
              de negocios; y realizar una evaluación de impacto en la protección
              de datos a fin de adoptar medidas técnicas y organizativas
              reforzadas para garantizar la integridad, confidencialidad y
              disponibilidad de los datos.
            </Typography>

            <Typography variant="body1" sx={{ marginBottom: "10px" }}>
              <strong>¿Por cuánto tiempo conservaremos sus datos?</strong>
            </Typography>
            <Typography variant="body2" sx={{ marginBottom: "10px" }}>
              Los datos personales se conservarán mientras dure la relación de
              negocio y/o se lleve a cabo la operación y durante un periodo de
              diez años desde la terminación de la relación de negocio o la
              ejecución de la operación ocasional, de conformidad con dispuesto
              en la Ley 10/2010, de 28 de abril, de PBCFT.
            </Typography>

            <Typography variant="body1" sx={{ marginBottom: "10px" }}>
              <strong>
                ¿Cuál es la legitimación para el tratamiento de sus datos?
              </strong>
            </Typography>
            <Typography variant="body2" sx={{ marginBottom: "10px" }}>
              La base legal para el tratamiento de sus datos personales para la
              finalidad arriba indicada es el cumplimiento de una obligación
              legal aplicable a este establecimiento. En concreto, en su
              condición de sujeto obligado, ha de dar debido cumplimiento a las
              obligaciones de identificación y diligencia debida establecidas en
              la Ley 10/2010, de 28 de abril, de PBCFT y en el Real Decreto
              304/2014, de 5 de mayo, de desarrollo de dicha Ley.
            </Typography>

            <Typography variant="body1" sx={{ marginBottom: "10px" }}>
              <strong>¿A qué destinatarios se comunicarán sus datos?</strong>
            </Typography>
            <Typography variant="body2" sx={{ marginBottom: "10px" }}>
              Además de los encargados de tratamiento que nos prestan servicios,
              en cumplimiento de la referida normativa también podremos
              comunicar sus datos al SEPBLAC, a la Comisión de Prevención del
              Blanqueo de Capitales e Infracciones Monetarias (CPBCIM). A
              autoridades judiciales y/o de policía, autoridades
              gubernamentales, fuerzas y cuerpos de seguridad y organismos
              regulatorios, cuando recibamos un requerimiento o cuando lo exijan
              las leyes.
            </Typography>

            <Typography variant="body1" sx={{ marginBottom: "10px" }}>
              <strong>
                ¿Cuáles son sus derechos cuando nos facilita sus datos?
              </strong>
            </Typography>
            <Typography variant="body2" sx={{ marginBottom: "10px" }}>
              Cualquier persona tiene derecho a obtener confirmación sobre si en{" "}
              {companyName} estamos o no tratando datos personales que le
              conciernen. Las personas interesadas también tienen derecho a
              acceder a sus datos personales, así como a solicitar la
              rectificación de los datos inexactos o, en su caso, a solicitar su
              supresión cuando, entre otros motivos, los datos ya no sean
              necesarios para los fines que fueron recogidos.
              <br />
              En los casos previstos en la normativa, tiene derecho a la
              portabilidad de sus datos. En determinadas circunstancias, podrá
              solicitar la limitación del tratamiento de sus datos, en cuyo
              caso, con excepción de su conservación, únicamente los trataremos
              para la formulación, el ejercicio o la defensa de reclamaciones o
              en los demás supuestos previstos en la legislación aplicable.
              <br />
              En determinadas circunstancias y por motivos relacionados con su
              situación particular, usted podrá oponerse al tratamiento de sus
              datos. Dejaremos de tratar los datos, salvo por motivos legítimos
              imperiosos, o para la formulación, el ejercicio o la defensa de
              posibles reclamaciones.
            </Typography>

            <Typography variant="body2" sx={{ marginBottom: "10px" }}>
              Puede ejercitar sus derechos en cualquiera de nuestros centros de
              trabajo, o bien dirigir una solicitud, adjuntando el documento que
              acredite su identidad y la descripción de su solicitud, por correo
              postal a {companyName}, {companyAddressType}, por e-mail a{" "}
              {companyMail} o llamando a {companyPhone}.
            </Typography>

            <Typography variant="body2">
              Declaro haber entendido la información facilitada y entiendo el
              tratamiento que se efectuará de mis datos de carácter personal.
            </Typography>
            {error && (
              <Typography
                variant="body2"
                sx={{ color: "red", marginBottom: "20px" }}
              >
                Debes aceptar los términos para continuar.
              </Typography>
            )}
            {apiError && (
              <Typography
                variant="body2"
                sx={{ color: "red", marginBottom: "20px" }}
              >
                Error en la comunicacion con el servidor.
              </Typography>
            )}
            {/* Checkbox para aceptar los términos */}
            <FormControlLabel
              control={
                <Checkbox
                  checked={isAccepted}
                  onChange={(e) => setIsAccepted(e.target.checked)}
                  color="success"
                />
              }
              label={
                <Typography variant="body2">
                  He leído y acepto la Política de Privacidad.
                </Typography>
              }
            />

            {/* Botón para continuar */}
            <Grid container spacing={2} justifyContent="space-between">
              <Grid item xs={12} lg={6}>
                <Button
                  variant="outlined"
                  color="secondary"
                  fullWidth
                  onClick={previousStep}
                  sx={{
                    mt: 2,
                    backgroundColor: "#FFF",
                    display: {
                      xs: "none", // Ocultar en pantallas pequeñas (móviles)
                      sm: "none", // Ocultar en tablets
                      md: "block", // Mostrar en pantallas medianas y grandes
                    },
                  }}
                >
                  Volver
                </Button>
              </Grid>

              <Grid item xs={12} lg={6}>
                <Button
                  variant="contained"
                  onClick={handleAccept}
                  fullWidth
                  sx={{
                    mt: 2,
                    backgroundColor: "black",
                    color: "white",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#333",
                    },
                  }}
                >
                  Aceptar y continuar
                </Button>
              </Grid>
            </Grid>

          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default LegalTermsCardEsp;
